import classnames from 'classnames';
import React, { ChangeEventHandler, ReactElement } from 'react';
import { IconButton } from '../IconButton';
import { FormGroupText } from '../FormGroup';
import styles from './index.module.css';

export interface SearchProps {
  id: string;
  label?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  value: string;
}

export function Search({
  id,
  label,
  onChange,
  placeholder,
  value,
}: SearchProps): ReactElement {
  const classes = classnames('form-group input--icon', styles.root);

  return (
    <div className={classes}>
      <FormGroupText>
        <input
          id={id}
          type="search"
          onChange={onChange}
          placeholder={placeholder}
          value={value}
        />
        {label && <label htmlFor={id}>{label}</label>}
        <IconButton icon="search" className="link" aria-label="Search" />
      </FormGroupText>
    </div>
  );
}
